import { makeAnonEdgeHttpClient } from '@/main/factories/http'
import { makeSupabaseClient } from '@/shared/infra/supabase'
import { SupabaseSendOtpRepository } from '@/modules/auth/infra'
import type { SendOtp } from '@/modules/auth/use-cases'
import { makeOtpFlowMemory } from './make-otp-flow-memory'

export function makeSendOtp(): SendOtp {
  return new SupabaseSendOtpRepository(
    makeSupabaseClient(),
    makeAnonEdgeHttpClient(),
    makeOtpFlowMemory(),
  ).execute
}
